import _ from 'lodash';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import CreateProvider from '../../../cnr/contexts/CreateContext';
import { appIconTypes } from '../../../enums/appIconTypes';
import { settingFormTypes } from '../../../enums/settingFormTypes';
import UiSaveButtons from '../../../components/buttons/UiSaveButtons';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';
import SettingsFormEdit from '../../subComponents/SettingsFormEdit';
import TreeViewer from '../../../components/viewers/TreeViewer';
import WrapperVertCols from '../../../wrappers/WrapperVertCols';
import { isMeProd } from '../../../../project/appConfiguration';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { createHandlers, createInitialState, createReducer, createTypes } from '../../../cnr/reducers/CreateReducer';
import { PapsContext } from '../../../cnr/contexts/PapsContext';
import { PageContext } from '../../../cnr/contexts/PageContext';
import SidebarWrapper from 'global/wrappers/SidebarWrapper';
import DataSidebar from 'global/components/swipers/DataSidebar';

const stepTypes = {
  client: 'client',
  createInfo: 'createInfo',
  clientColors: 'clientColors',
  confirmation: 'confirmation',
}

const CreateClient = (props) => {

  const parentContext = useContext(ParentContext)
  const { settings, fns, fn_cls } = parentContext ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { globalAppSettings } = homeSettings_global ?? {}
  const { databaseProjectId } = globalAppSettings ?? {}
  const { database_fns, appSettings_fns } = fns ?? {}

  const papsContext = useContext(PapsContext);
  const pageContext = useContext(PageContext);

  const componentContexts = { homeSettings, papsContext, pageContext }

  const initInfo = {}

  const create_initState = { fn_cls, database_fns, componentContexts, initInfo, createType: createTypes.createClient }
  const [create_state, create_dispatch] = useReducer(createReducer, createInitialState(create_initState));
  const create_handlers = createHandlers(create_dispatch)
  const { createInfo, updating, confirmation } = create_state ?? {}

  const [clientInfo, setClientInfo] = useState({});
  const [themeColors, setThemeColors] = useState({});
  const [sidebarMode, setSidebarMode] = useState()

  const { name, clientType, clientKey } = clientInfo ?? {}

  const _disabled = !name || !clientType ? true : false

  const eventOptions = { themeColors }

  useEffect(() => {
    create_handlers.handleStartUpdate()
    create_handlers.handleCreate_clientProjectSettings(null, clientInfo)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [clientInfo]);

  useEffect(() => {
    if (createInfo) {
      const _createInfo = { ...createInfo }
      if (eventOptions) {
        _.forEach(eventOptions, (eo, eok) => {
          _createInfo.projectSettings.global[eok] = eo
        })
      }
      create_handlers.handleUpdate_createInfo(_createInfo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [themeColors]);

  const handleThemeColors = (tcs) => {
    setTimeout(() => {
      setThemeColors(tcs);
    }, 2000); // 2-second delay
  };

  const handleCreate = () => setSidebarMode(true)

  const handleCreateClient = () => {

    createInfo.projectData.clientData.name = createInfo.projectData.clientData.dataItems.name

    create_handlers.handleStartUpdate()
    const d = { createInfo: createInfo, forProd: isMeProd(), databaseProjectId, clientKey: clientKey }
    fn_cls.createClientInDatabase(d).then(response_data => {
      const { success, error } = response_data
      create_handlers.handleStopUpdate()
      console.log('response_data', response_data)
    }).catch(err => {
      create_handlers.handleStopUpdate()
      console.log('e', err)
    })
  }

  const _client = () => <SettingsFormEdit settingsType={settingFormTypes.createClient} formData={clientInfo} updateForm={setClientInfo} isGlobal={true} />
  const _eventColors = () => <SettingsFormEdit settingsType={settingFormTypes.themeColors} formData={themeColors} updateForm={handleThemeColors} isGlobal={true} />

  const settingsViewer = () => <TreeViewer
    data={createInfo}
    scNames={true}
  />

  const saveButtons = () => <UiSaveButtons
    save={{ oc: handleCreate, caption: _.startCase('createClient'), color: 'blue', disabled: _disabled, icon: appIconTypes.arrowRight }}
  />

  const buttons_create = () => {
    const btns = []
    btns.push({ oc: handleCreateClient, caption: 'Create Client', color: 'green', icon: appIconTypes.save })

    return <UiSaveButtons others={btns} />
  }

  const content_right = () => {

    const create_info = _.cloneDeep(createInfo)

    return <Wrapper
      header={'Confirmation'}
      content={<TreeViewer data={create_info} subNames={true} scNames={true} />}
      footer={buttons_create()}
      wrapperType={wrapperTypes.padded}
    />
  }

  const sidebar_right = (visible) => <DataSidebar direction={'right'} visible={visible} content={visible && content_right()} onHide={setSidebarMode} />

  const content = () => <WrapperVertCols mvc={'1-2-2'}>
    {_client()}
    {_eventColors()}
    {settingsViewer()}
  </WrapperVertCols>

  const wrapper = () => <Wrapper
    content={content()}
    footer={saveButtons()}
    updating={updating}
    wrapperType={wrapperTypes.paddedFooter}
  />

  const sidebar = () => <SidebarWrapper
    sidebarContent={wrapper()}
    sidebarRight={sidebar_right(sidebarMode)}
    sidebarOn={sidebarMode}
  />

  return sidebar()

}

export default CreateClient

export const CreateClientWithProvider = () => {
  return <CreateProvider>
    <CreateClient />
  </CreateProvider>
} 